import React from "react";
import { RadioButtonProps } from "./RadioButton.types";
import {
  RadioButtonStyled,
  RadioButtonContainer,
  RadioButtonWrapper,
  RadioIcon,
} from "./RadioButton.styles";
import {
  Body3MediumTypography,
  Body3RegularTypography,
} from "../../primitives/Typography/typographyVariants";

export const RadioButton: React.FC<RadioButtonProps> = ({
  selected = false,
  onChange,
  label,
  value,
  disabled = false,
  dataCy,
  name = label,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onChange({
      label: label,
      value: value,
    });
  };
  return (
    <>
      <label onClick={handleClick} data-cy={dataCy}>
        <RadioButtonWrapper>
          <RadioButtonContainer selected={selected} disabled={disabled}>
            <RadioIcon selected={selected} disabled={disabled} />
          </RadioButtonContainer>
          {selected ? (
            <Body3MediumTypography>{label}</Body3MediumTypography>
          ) : (
            <Body3RegularTypography>{label}</Body3RegularTypography>
          )}
        </RadioButtonWrapper>
        <RadioButtonStyled
          type="radio"
          name={name}
          value={value}
          onChange={() => handleClick}
          disabled={disabled}
        />
      </label>
    </>
  );
};
